module.exports = __webpack_public_path__ + "img/ORENBUR.593bc0de.png";